import { catalog } from '@/utils/gestaoPolicy'
export const gestaoPermissions = {
  grupo: 'Gestão',
  categorias: [
    { nome: 'Menu Lateral', acoes: [{ value: 'menu_gestao', text: 'Exibir' }] },
    ...['grafico', 'relatorio'].flatMap(kind => [...new Set(catalog.filter(item => item.kind === kind).map(item => item.category))].map(category => ({
      nome: `${kind === 'grafico' ? 'Gráficos' : 'Relatórios'} — ${category}`,
      acoes: catalog.filter(item => item.kind === kind && item.category === category).map(item => ({ value: item.permission, text: item.label })),
    }))),
  ],
}
